import React from 'react'
import Sample from '../sample'

import Loading from '../icon/loading'

class LoadingSample extends Sample {
    static ID = 0;

    pathI18n = 'sample.app.components.loading.'
    state = {}

    getTitle() {
        return this.pathI18n + 'page.title'
    }

    getBody() {
        let loadingTypes = ["bars", "bubbles", "cylon", "spin", "spinningBubbles"]
        return <div className="sample sample-loading">
            {loadingTypes.map(t => <Loading printable={true} type={t} key={'LoadingSample' + LoadingSample.ID++} />)}
        </div>
    }
}

export default LoadingSample
